import ListWithTotal from 'common/dto-types/list-with-total-dto';
import UserDto from 'common/dto-types/user-dto';
import axiosServices, { PaginationAndFiltersParams, buildQueryParams } from 'utils/axios';

export const USER_API_URL = '/mediaHubUsers';

export const fetchUserList = async (
    params: PaginationAndFiltersParams,
): Promise<ListWithTotal<UserDto> | null | undefined> => {
    try {
        const res = await axiosServices.get(`${USER_API_URL}${buildQueryParams(params)}`);
        return res.data;
    } catch (err) {
        // TODO: Implement a proper way to handle errors
        // https://fifadigital.atlassian.net/browse/FMH-2075
        console.error(err);
        return null;
    }
};

/**
 * Fetches active users for messaging with optional group restrictions
 * If groupIds are provided, only users belonging to those groups are returned
 */
export const fetchActiveUserForMessaging = async (
    params: PaginationAndFiltersParams,
    groupIds?: number[],
): Promise<ListWithTotal<UserDto> | null | undefined> => {
    const activeUserSpec = 'IsActiveSpecification:true';
    const specifications: string[] = [activeUserSpec];

    // Add group restriction if provided
    if (groupIds && groupIds.length > 0) {
        const groupSpec = `GroupIdsSpecification:${groupIds.join(';')}`;
        specifications.push(groupSpec);
    }

    // Merge all specifications
    const mergedParams: PaginationAndFiltersParams = {
        ...params,
        andSpecifications: params.andSpecifications
            ? `${params.andSpecifications},${specifications.join(',')}`
            : specifications.join(','),
    };

    return fetchUserList(mergedParams);
};
